import type { StaticImageData } from 'next/image';
import staticHeaderImg from './assets/staticHeader.png';
import heroCircuitImg from './assets/heroCircuit.webp';
import heroRibbonImg from './assets/heroRibbon.webp';
import heroApertureImg from './assets/heroAperture.webp';
import heroCorridorImg from './assets/heroCorridor.webp';

export type HeroBackground = {
  image: StaticImageData;
  /** Decorative backgrounds should keep an empty alt. */
  alt: string;
  /**
   * Photos need a dark wash on the left so the white hero copy stays legible.
   * Abstract gradient artwork is already dark enough and skips it.
   */
  dim?: boolean;
};

/**
 * Backgrounds cycled by the home hero. Copy on top of them never changes.
 *
 * The first is the approved one; the rest are candidates pulled from the Figma
 * hero board (node 10345:77826), which has thirteen proposals and no decision
 * yet. They were picked for a dark left third — that is where the white copy
 * sits — and for being blue-dominant; measured mean luma over the left 42% is
 * 25, 21, 3 and 46 respectively, which is why only the last one is dimmed.
 */
export const heroBackgrounds: HeroBackground[] = [
  { image: staticHeaderImg, alt: '' },
  { image: heroCircuitImg, alt: '' },
  { image: heroRibbonImg, alt: '' },
  { image: heroApertureImg, alt: '' },
  { image: heroCorridorImg, alt: '', dim: true },
];
